export default __webpack_public_path__ + "static/media/Heart-filled-remove.27333c8f.gif";